import { render, staticRenderFns } from "./OtherMail.vue?vue&type=template&id=8a3ff94c"
import script from "./OtherMail.vue?vue&type=script&lang=js"
export * from "./OtherMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports